import { useCallback, useEffect, useMemo, useState } from "react";

import { Badge, Card, CardBody, Col, Container, Row } from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";
import TableContainer from "../../Components/Common/TableContainer";
import BreadCrumb from "../../Components/Common/BreadCrumb";

//redux
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Loader from "../../Components/Common/Loader";
import {
  useHideQuestion,
  useQuestions,
  useUnhideQuestion,
} from "../../hooks/useQuestions";
import { useUsersList } from "../../hooks/useUsersList";

const QuestionsAnswersPage = (props) => {
  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const questionsQ = useQuestions({ search: debouncedSearch });
  const usersListQ = useUsersList();
  const hideQuestion = useHideQuestion();
  const unhideQuestion = useUnhideQuestion();

  const questions = useMemo(() => questionsQ.data || [], [questionsQ.data]);
  const usersList = useMemo(() => usersListQ.data || [], [usersListQ.data]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput.trim());
    }, 500);
    return () => clearTimeout(timer);
  }, [searchInput]);

  const userNameById = useCallback(
    (id) => {
      if (!id) return "-";
      const u = usersList.find((x) => x?.id === id);
      return u?.username || "-";
    },
    [usersList]
  );

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const handleDeleteProduct = () => {
    if (questions) {
      // dispatch(deleteProducts(articles.id));
      setDeleteModal(false);
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      // dispatch(deleteProducts(element.value));
      del.style.display = "none";
    });
  };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };
  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("ENVOYE PAR"),
        Cell: (assistance) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1" style={{ fontWeight: "bold" }}>
                {(() => {
                  const requestor = assistance.row.original.requestor;
                  const fullName = requestor?.profile
                    ? `${requestor.profile?.first_name || ""} ${
                        requestor.profile?.last_name || ""
                      }`.trim()
                    : "";
                  return (
                    fullName || requestor?.username || requestor?.email || "-"
                  );
                })()}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TYPE"),
        Cell: (assistance) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {assistance.row.original.requestor?.profile?.user_type || "-"}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("REPONSES"),
        accessor: "_response",
        Cell: (assistance) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <p>{assistance.row.original?._response?.length || 0}</p>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("QUESTION"),
        Cell: (assistance) => (
          <>
            <div
              className="d-flex align-items-center"
              style={{
                width: 300,
                height: 70,
                overflow: "clip",
                verticalAlign: "middle",
              }}
            >
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <p>{assistance.row.original.question_text}</p>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("PRIS PAR"),
        Cell: (assistance) => (
          <>
            <div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <p style={{ fontStyle: "italic" }}>
                    {assistance.row.original.taken_by ? (
                      userNameById(assistance.row.original.taken_by)
                    ) : (
                      <h5
                        className="mb-1 badge badge-soft-danger me-1 "
                        style={{ textAlign: "center" }}
                      >
                        Non
                      </h5>
                    )}
                  </p>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("DERNIERE REPONSE"),
        Cell: (assistance) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p style={{ marginBottom: 0 }}>
                  {assistance.row.original?._response?.[0]?.response_text ||
                    "-"}
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("REPONDU PAR"),
        Cell: (assistance) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {assistance.row.original?._response?.[0]?.responder?.username ||
                  "-"}
              </div>
            </div>
          </>
        ),
      },
      {
        // Which trade the asker aimed at, or that it went to every expert.
        Header: props.t("MÉTIER"),
        Cell: (assistance) => {
          const metier = assistance.row.original.metier;
          return metier?.label ? (
            <span className="badge badge-soft-primary">{metier.label}</span>
          ) : (
            <span className="text-muted fs-12">{props.t("Tous les experts")}</span>
          );
        },
      },
      {
        // The lifecycle, which the table could not show before: a question was
        // either "Répondu" or "En attente", with no way to tell one being
        // handled from one closed, nor from one an unsatisfied asker sent back
        // for another expert.
        Header: props.t("STATUT"),
        Cell: (assistance) => {
          const row = assistance.row.original;
          // `status` is authoritative; the booleans cover an older payload.
          const status =
            row.status || (row.taken_by ? "EN_COURS" : "OUVERTE");

          const TONES = {
            OUVERTE: { tone: "warning", label: props.t("Ouverte") },
            EN_COURS: { tone: "info", label: props.t("En cours") },
            RESOLUE: { tone: "success", label: props.t("Résolue") },
          };
          const badge = TONES[status] || TONES.OUVERTE;

          return (
            <div className="d-flex align-items-center">
              <span className={`badge badge-soft-${badge.tone} me-1`}>
                {badge.label}
              </span>
              {/* A question closed on a negative verdict is open again, and
                  saying so is the difference between "nobody has taken it" and
                  "the first expert did not satisfy the asker". */}
              {row.satisfied === false ? (
                <span className="badge badge-soft-danger">
                  {props.t("Non satisfait")}
                </span>
              ) : null}
            </div>
          );
        },
      },

      {
        Header: props.t("VISIBILITE"),
        Cell: (assistance) => (
          <div className="d-flex align-items-center">
            <div className="flex-grow-1">
              {assistance.row.original.hidden_at ? (
                <h5
                  className="mb-1 badge badge-soft-danger me-1"
                  style={{ textAlign: "center" }}
                >
                  Masquée
                </h5>
              ) : (
                <h5
                  className="mb-1 badge badge-soft-success me-1"
                  style={{ textAlign: "center" }}
                >
                  Visible
                </h5>
              )}
            </div>
          </div>
        ),
      },

      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const assistancesData = cellProps.row.original;
          return (
            <>
              {/* Offered only while the question is genuinely free. This used
                  to read `taken`, and answering is refused server-side once an
                  expert holds the question — so the button appeared on rows
                  where it could not work. `status` is the field to trust;
                  `taken_by` covers a payload from before it existed. */}
              {(assistancesData.status
                ? assistancesData.status === "OUVERTE"
                : !assistancesData.taken_by) && (
                <li className="list-inline-item" title={props.t("Répondre")}>
                  {
                    <div className="btn btn-soft-warning">
                      <Link
                        to={`/questions-answers-add/${assistancesData.id}/`}
                      >
                        {props.t("Répondre")}
                      </Link>
                    </div>
                  }
                </li>
              )}
              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/questions-answers-details/${assistancesData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
              {/* Moderation is after the fact and reversible: a question is
                  public as soon as it is asked, and this is how it comes
                  down — or goes back up. */}
              <li
                className="list-inline-item"
                title={
                  assistancesData.hidden_at
                    ? props.t("Réafficher")
                    : props.t("Masquer")
                }
              >
                <button
                  type="button"
                  className={`btn btn-sm ${
                    assistancesData.hidden_at
                      ? "btn-soft-success"
                      : "btn-soft-danger"
                  }`}
                  disabled={hideQuestion.isPending || unhideQuestion.isPending}
                  onClick={() =>
                    assistancesData.hidden_at
                      ? unhideQuestion.mutate(assistancesData.id)
                      : hideQuestion.mutate(assistancesData.id)
                  }
                >
                  <i
                    className={`${
                      assistancesData.hidden_at
                        ? "ri-eye-line"
                        : "ri-eye-off-line"
                    } align-bottom`}
                  ></i>
                </button>
              </li>
            </>
          );
        },
      },
    ],
    [props, userNameById, hideQuestion, unhideQuestion]
  );

  document.title = props.t("Questions/Réponses");

  const pendingCount = questions.filter((item) => !item?.responded).length;
  const answeredCount = questions.filter((item) => item?.responded).length;

  if (questionsQ.isLoading) {
    return <Loader />;
  }

  if (questionsQ.isError) {
    return (
      <Loader
        error={
          questionsQ.error?.message ||
          props.t("Erreur lors du chargement")
        }
      />
    );
  }

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProduct}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Questions/Réponses")}
          pageTitle={props.t("Questions/Réponses")}
        />
        <Row className="mb-3">
          <Col md={4}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <p className="text-muted mb-2">{props.t("Total des questions")}</p>
                <h4 className="mb-0">{questions.length}</h4>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <p className="text-muted mb-2">{props.t("En attente")}</p>
                <h4 className="mb-0 text-warning">{pendingCount}</h4>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <p className="text-muted mb-2">{props.t("Répondues")}</p>
                <h4 className="mb-0 text-success">{answeredCount}</h4>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-body pt-0">
                  {questions && questions.length > 0 ? (
                    <div>
                      {questionsQ.isFetching ? (
                        <div className="text-muted small mb-2">
                          {props.t("Mise à jour des résultats...")}
                        </div>
                      ) : null}
                      <TableContainer
                        columns={columns}
                        data={questions || []}
                        isGlobalFilter={true}
                        globalSearchWidth="460px"
                        globalSearchDebounceMs={500}
                        globalSearchValue={searchInput}
                        onGlobalSearchChange={setSearchInput}
                        isAddUserList={false}
                        customPageSize={10}
                        divClass="table-responsive mb-1"
                        tableClass="mb-0 align-middle "
                        theadClass="table-light text-muted"
                      />
                    </div>
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Aucune question trouvée")}</h5>
                        <p className="text-muted mb-0">
                          {props.t(
                            "Essayez une autre recherche ou attendez de nouvelles questions."
                          )}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

QuestionsAnswersPage.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(QuestionsAnswersPage));
